import React from 'react';
import GCEInstruction from './GCEInstruction';
import { ExamType } from '../../../../api/candidate/exam/model';
import PsleInstruction from './PsleInstruction';
import IPsleInstruction from './IPsleInstruction';

const ExamInstruction = (props: { examType: string; examRegistrationType: string }) => {
  const { examType, examRegistrationType } = props;

  if (examType === 'PSLE') {
    return <PsleInstruction />;
  }

  if (examType === ExamType.GCE) {
    return <GCEInstruction />;
  }

  return <IPsleInstruction examRegistrationType={examRegistrationType} />;
};

export default ExamInstruction;
